// extracted by mini-css-extract-plugin
export default {"badge":"PriceBadge_badge__Xa7Fa"};